/* Video inventory, worldwide — client-side filter + sort.
   Country chips · Country pills · Type pills · Sort dropdown.
   Filters the .vam-card grid by data attributes. */
(function () {
  function init() {
    var root = document.querySelector("[data-vam-root]");
    if (!root) return;
    var cards = Array.from(root.querySelectorAll(".vam-card"));
    var grid = root.querySelector(".vam-grid");
    var emptyEl = root.querySelector("[data-vam-empty]");
    var countEl = root.querySelector("[data-vam-count]");
    var sortSel = root.querySelector("[data-vam-sort]");
    var pillsCountry = root.querySelectorAll("[data-vam-country]");
    var pillsType = root.querySelectorAll("[data-vam-type]");
    var chips = root.querySelectorAll("[data-vam-chip]");

    var state = { country: "all", type: "all", sort: "featured" };
    var originalOrder = cards.slice();

    function activatePill(list, val) {
      list.forEach(function (b) {
        b.classList.toggle("is-active", b.getAttribute("data-value") === val);
      });
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (c) {
        var country = c.getAttribute("data-country") || "";
        var type = c.getAttribute("data-type") || "";
        var matchCountry = state.country === "all" || country === state.country;
        var matchType = state.type === "all" || type === state.type;
        if (matchCountry && matchType) {
          c.classList.remove("is-hidden");
          visible++;
        } else {
          c.classList.add("is-hidden");
        }
      });
      if (countEl) countEl.textContent = visible;
      if (emptyEl) emptyEl.classList.toggle("is-on", visible === 0);
      activatePill(pillsCountry, state.country);
      activatePill(pillsType, state.type);
    }

    function sortCards() {
      var sorted = originalOrder.slice();
      if (state.sort === "price-asc") {
        sorted.sort(function (a, b) {
          return Number(a.getAttribute("data-price") || 0) - Number(b.getAttribute("data-price") || 0);
        });
      } else if (state.sort === "price-desc") {
        sorted.sort(function (a, b) {
          return Number(b.getAttribute("data-price") || 0) - Number(a.getAttribute("data-price") || 0);
        });
      } else if (state.sort === "name") {
        sorted.sort(function (a, b) {
          return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || "");
        });
      }
      sorted.forEach(function (c) { grid.appendChild(c); });
    }

    pillsCountry.forEach(function (b) {
      b.addEventListener("click", function () {
        state.country = b.getAttribute("data-value");
        apply();
      });
    });
    pillsType.forEach(function (b) {
      b.addEventListener("click", function () {
        state.type = b.getAttribute("data-value");
        apply();
      });
    });
    chips.forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-value");
        state.country = (state.country === v) ? "all" : v;
        apply();
        var f = root.querySelector(".vam-filters");
        if (f) f.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
    if (sortSel) {
      sortSel.addEventListener("change", function () {
        state.sort = sortSel.value;
        sortCards();
        apply();
      });
    }

    apply();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
